import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';

import { Comment } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

interface CommentBodyProps {
    comment: Comment
}

export const CommentBody = ({ comment }: CommentBodyProps) => {
    
    return (
        <Typography
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(comment.renderedBody),
          }}
          sx={{
            marginBottom: 2,
            '& img': {
              maxWidth: '50%',
              height: 'auto',  
              display: 'inline-block',
              float: 'left', 
              margin: '0 10px 10px 0', 
            },
          }}
        />
      );
    };
